<template>
  <div class="rsu">
    <div class="px-4">
      <v-flex xs12 v-for="(formitem, k) in formdata.formitems" :key="k" class="form-control">
        <div class="mb-2" v-if="['หัวข้อ'].includes(formitem.questiontype)">
          <Typography h3 semiBold color="darkGrey" :class="`mb-2 ${formitem.isRequired ? 'dataReq' : ''}`" :label="formitem.name" />
          <v-divider style="border-color:#BECCDB" />
        </div>
        <div
          class="mb-2"
          v-if="['ข้อความ', 'กล่องข้อความ', 'คำตอบสั้นๆ'].includes(formitem.questiontype)"
        >
          <div class="input-ans">
            <Typography
              h5
              semiBold
              color="darkGrey"
              :class="`mb-2 ${formitem.isRequired ? 'dataReq' : ''}`"
              :label="formitem.name"
            />
            <input
              :name="'form' + k"
              :placeholder="customPlaceholder(formitem.Options)"
              type="text"
              class="depainput rsu mb-0"
              readonly
            />
          </div>
        </div>
        <div class="mb-2" v-if="['บทความ'].includes(formitem.questiontype)">
          <Typography h5 semiBold color="darkGrey" :class="`mb-2 ${formitem.isRequired ? 'dataReq' : ''}`" :label="formitem.name" />
        </div>
        <div class="mb-2" v-if="['เลื่อนลง'].includes(formitem.questiontype)">
          <Typography h5 semiBold color="darkGrey" :class="`mb-1 ${formitem.isRequired ? 'dataReq' : ''}`" :label="formitem.name" />
          <DropdownMenu
            v-model="formitem.defaultOptions"
            :options="formitem.fields"
            :textLabel="'label'"
            :textValue="'label'"
          >
            <div style="position: relative" class="form-control">
              <input
                :value="formitem.defaultOptions"
                placeholder="เลือก"
                type="text"
                class="option-input rsu"
                style="cursor: pointer"
              />
            </div>
          </DropdownMenu>
        </div>
        <div class="mb-2" v-if="['อัปโหลดไฟล์'].includes(formitem.questiontype)">
          <Typography h5 semiBold color="darkGrey" :class="`mb-1 ${formitem.isRequired ? 'dataReq' : ''}`" :label="formitem.name" />
          <v-btn
            class="rsu customConfirmBtn ma-0 uploadBtn"
            round
            depressed
            color="primary"
            readonly
          >
            <img
              :src="`/static/icon/uploadYellowSvg.svg`"
              alt
              class="responsive-img mr-2"
              style="height: 13px;"
            />
            อัปโหลดไฟล์
          </v-btn>
          <Typography
            h7
            medium
            color="color-lightMediumGrey"
            class="mt-1"
            label="(จำนวนไฟล์ที่อัปโหลดแล้ว : 0 ไฟล์)"
          />
        </div>
        <div class="mb-2" v-if="['อัปโหลดลายเซ็น'].includes(formitem.questiontype)">
          <Typography h5 semiBold color="darkGrey" :class="`mb-1 ${formitem.isRequired ? 'dataReq' : ''}`" :label="formitem.name" />
          <v-btn
            class="rsu customConfirmBtn ma-0 uploadBtn"
            round
            depressed
            color="primary"
            readonly
          >
            <img
              :src="`/static/icon/uploadYellowSvg.svg`"
              alt
              class="responsive-img mr-2"
              style="height: 13px;"
            />
            อัปโหลดลายเซ็น
          </v-btn>
          <Typography
            h7
            medium
            color="color-lightMediumGrey"
            class="mt-1"
            label="(จำนวนไฟล์ที่อัปโหลดแล้ว : 0 ไฟล์)"
          />
        </div>
        <div v-else-if="formitem.questiontype == 'หลายตัวเลือก'">
          <Typography h5 semiBold color="darkGrey" :class="`mb-1 ${formitem.isRequired ? 'dataReq' : ''}`" :label="formitem.name" />
          <v-radio-group :readonly="isReadonly" :disabled="isReadonly" :value="formitem.value">
            <v-radio
              :key="k"
              :label="field.label"
              v-for="(field, k) in formitem.fields"
              :value="field.label"
            ></v-radio>
          </v-radio-group>
        </div>
        <div v-else-if="formitem.questiontype == 'ช่องทำเครื่องหมาย'" class="mb-3">
          <Typography h5 semiBold color="darkGrey" :class="`mb-1 ${formitem.isRequired ? 'dataReq' : ''}`" :label="formitem.name" />
          <div v-for="(field, k) in formitem.fields" :key="k">
            <v-checkbox
              v-model="formitem.value"
              :readonly="isReadonly"
              :disabled="isReadonly"
              :value="field.label"
              outlined
              hide-details
              dense
              :label="field.label"
            >
            </v-checkbox>
            <!-- <div>
              <FormDetailSubquestion
                :formdata="{ formitems: field.subquestion }"
                :showPreview="true"
              ></FormDetailSubquestion>

              {{ field.subquestion }}
            </div> -->
          </div>
        </div>
      </v-flex>
    </div>
  </div>
</template>

<script>
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea.vue'
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import uploadfile from '@/components/elements/uploadfile.vue'
import UploadDocument from '@/components/elements/UploadDocument.vue'
import draggable from 'vuedraggable'
import Typography from '@/components/elements/Typography.vue'
export default {
  props: ['formdata', 'showPreview'],

  components: {
    AutoresizeTextarea,
    DropdownMenu,
    uploadfile,
    UploadDocument,
    Typography,
    draggable: {
      extends: draggable
    }
  },
  data() {
    return {
      defaultAnswerOptions: [
        { label: '(ไม่มี)', value: '' },
        { label: 'ชื่อ', value: 'name' },
        { label: 'อีเมล', value: 'email' },
        { label: 'เบอร์โทรศัพท์', value: 'phone_number' },
        { label: 'หมายเลขบัตรประชาชน', value: 'id_card' },
        { label: 'เลขทะเบียนนิติบุคคล', value: 'id_card2' },
        { label: 'เลขประจำตัวผู้เสียภาษีอากร', value: 'id_card3' },
        { label: 'ทุนจดทะเบียน', value: 'regis_cap' },
        { label: 'ประเภทนิติบุคคล', value: 'membertype' },
        { label: 'Project Name', value: 'project_name' },
        { label: 'Member Type', value: 'membertype2' },
        { label: 'DP Status', value: 'dptype' },
        { label: 'Register Capital', value: 'RegisterCapital' },
        { label: 'Paid Register Capital', value: 'PaidRegisterCapital' },
        { label: 'เลขเกษตรกร', value: 'farmer_number' },
        { label: 'Member ID', value: 'u_memberid' },
        { label: '[Tech hunt] รหัสคูปอง (voucher)', value: 't_product_voucher' },
        { label: '[Tech hunt] ชื่อร้านค้า (DP) ', value: 't_shop_name' },
        { label: '[Tech hunt] ชื่อสินค้า', value: 't_product' },
        { label: '[Tech hunt] ประเภทสินค้า', value: 't_product_type' },
        { label: '[Tech hunt] หมวดหมู่สินค้า', value: 't_product_category' },
        { label: '[Tech hunt] member id ของ DP', value: 'shop_memberid' },
        { label: '[Tech hunt] เลขทะเบียนนิติบุคคลของ DP', value: 'shop_juristic_id' },
        { label: '[Tech hunt] หน่วยร่วม', value: 'agency' }
      ],
      defaultDateOptions: [
        { label: 'วันที่และเวลา', value: 'all' },
        { label: 'วันที่', value: 'date' },
        { label: 'เวลา', value: 'time' }
      ],
      nativeSelectedItems: [],
      menu: false,

      optionsStatus: ['กล่องข้อความ', 'หลายตัวเลือก', 'เลื่อนลง', 'ช่องทำเครื่องหมาย'],
      input: {
        name: '',
        questiontype: 'ช่องทำเครื่องหมาย',
        fields: [''],
        fields2: ['']
      }
    }
  },
  computed: {
    isReadonly() {
      return true
    }
  },
  inject: ['$validator'],
  methods: {
    customPlaceholder(text) {
      for (let i = 0; i < this.defaultAnswerOptions.length; i++) {
        if (this.defaultAnswerOptions[i].value === text) {
          if (text != ('(ไม่มี)' && '' && null && undefined)) {
            return `(${this.defaultAnswerOptions[i].label})`
          }else{
            return ``         
          }
        }
      }
    },
    showNameFormLink(link) {
      try {
        let tempLink = decodeURI(link)
        tempLink = tempLink.split('/')
        tempLink = tempLink[tempLink.length - 1]
        tempLink = tempLink.split('_')
        tempLink.shift()
        tempLink = tempLink.join('_')
        return tempLink
      } catch (error) {
        return link
      }
    },
    showItem(item) {
      window.open(item, '_blank').focus()
    },
    deleteItem: function(index) {
      var result = this.formdata.formitems
      var data = result.find(
        el =>
          el.questiontype == 'อัปโหลดไฟล์' ||
          el.questiontype == 'แนบไฟล์' ||
          el.questiontype == 'อัปโหลดเอกสาร' ||
          el.questiontype == 'อัปโหลดลายเซ็น'
      )
      var data_file = data.value
      data_file.splice(index, 1)
    }
  },
  filters: {
    showFilename(value) {
      var result = value
      if (result) {
        result = result.split('/')
        result = result[4].substring(13)
      }
      return result
    }
  }
}
</script>
<style lang="scss" scoped>
.customConfirmBtn {
  color: yellow !important;
  font-weight: 700;
  font-size: 16px;
  width: 142px;
  margin: 0 7px;
}
.dataReq {
  display: flex;
}
.dataReq::after {
  content: '*';
  color: red;
}
.uploadBtn {
  width: 185px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/projectMaster/FormDetailSubquestionPreview.vue